import type { ISessionData, IEventData } from './types'
import { isPageRefresh, getCurrentTimestamp } from './session'

export const createEventData = (
  accountId: string,
  sessionData: ISessionData,
  eventType: string,
  placement: string,
  additionalData: Record<string, any> = {},
  deviceFingerprint: string,
): IEventData => ({
  account: accountId,
  deviceFingerprint,
  eventType,
  placement,
  sessionId: sessionData.sessionId,
  vehicle: { ...additionalData },
})
